import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import { orderBy } from 'lodash' // chain
import ReactTooltip from 'react-tooltip'
import { Row, Col } from 'react-flexbox-grid'
import format from '../../helpers/format'
// import { Link, LinkIcon } from '../'
import Styles from './CompanyList.css'


@CSSModules(Styles, {allowMultiple:true})
class HoldingRow extends Component {
  static propTypes = {
    idx: PropTypes.number.isRequired,
    highLow: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    holding: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    scoreCode: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props)
    const scoreLabel = {
      gef: 'Gender Equality',
      dei: 'Diversity Disclosures',
      rji: 'Racial Justice',
      hrc: 'LGBTQ+ Equity',
    }[props.scoreCode || 'gef'] 
    this.state = {
      tableIdx: props.idx + 1,
      security_name: props.holding.security_name,
      market_value: props.holding.market_value,
      long_weight: props.holding.long_weight,
      score: props.holding[props.scoreCode+'_score'],
      tooltipHtml: `
        ${props.holding.security_name} is the ${props.highLow} scored holding
        for ${scoreLabel} in this fund
      `
    }
  }
  //
  render() {
    return <li
      styleName='holding'
      title={this.state.security_name}
    >
      {
        this.props.idx===0 ?
          <div
            styleName={'holding-name-'+this.props.highLow}
            data-multiline
            data-effect='solid'
            data-place='top'
            data-for={this.props.type+'-tip'}
            data-html
            // data-scroll-hide={false}
            data-tip={this.state.tooltipHtml}
          >
            { this.state.tableIdx }. { this.state.security_name }
            <ReactTooltip id={this.props.type+'-tip'}/>
          </div> :
          <div styleName='holding-name'>
            { this.state.tableIdx }. { this.state.security_name }
          </div>
      }

      {
        this.props.scoreCode !== 'gef' ?
          <div styleName='holding-asset'>
            <span styleName='hidden-sm hidden-md hidden-lg'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {
                (
                {
                  'gef': 'Gender Equality',
                  'dei': 'Diversity Disclosures',
                  'rji': 'Racial Justice',
                  'hrc': 'LGBTQ+ Equity',
                }[this.props.scoreCode]
                ) ?
                  (
                {
                  'gef': 'Gender Equality',
                  'dei': 'Diversity Disclosures',
                  'rji': 'Racial Justice',
                  'hrc': 'LGBTQ+ Equity',
                }[this.props.scoreCode]
                  ) :
                  null
              }
              &nbsp;Score:&nbsp;
            </span>
            {
              format.number( // number, showHuman, currency, lightFormat, decimals=2
                this.state.score,
                false,
                false,
                (this.props.scoreCode === 'rji' ? 1 : 0)
              )
            }
          </div> :
          null
      }

      <div styleName='holding-invested'>
        <span styleName='hidden-sm hidden-md hidden-lg'>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;% of fund invested:&nbsp;
        </span>
        { format.perc(this.props.holding.long_weight) }
      </div>

      <div styleName='holding-invested'>
        <span styleName='hidden-sm hidden-md hidden-lg'>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$USD invested:&nbsp;
        </span>
        {
          format.money(
            this.props.holding.market_value,
            true,
            this.props.currency,
            true
          )
        }
      </div>

    </li>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class HoldingListTable extends Component {
  static propTypes = {
    currency: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    holdings: PropTypes.array.isRequired,
    scoreCode: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props)
    const highLowLabel = {
      top: 'Highest scoring holdings',
      bottom: 'Lowest scoring holdings',
    }[props.type]
    this.state = {
      label: String(props.type).charAt(0).toUpperCase() + String(props.type).slice(1) + ' scoring holdings',
      highLowLabel
    }
  }
  render() {
    const highLow = this.props.type === 'top' ? 'highest' : 'lowest'
    const upArrow = require( '../../../static/images/holdings-up-arrow.svg' )
    const downArrow = require( '../../../static/images/holdings-down-arrow.svg' )

    return <div styleName='table-wrap'>
      <div styleName='table-header'>
        <img
          src={this.props.type === 'top' ? upArrow : downArrow}
          alt={this.state.highLowLabel}
          styleName='img-arrow'
        />
        <div>
          <h3 styleName='table-header-title'>
            {this.state.highLowLabel}
          </h3>
          <p styleName='table-header-description'>
            {this.props.description}
          </p>
        </div>
      </div>

      <ul styleName='table'>
        
        <li styleName='holding hidden-xs'>
          <div styleName='holding-name'>
            Holding
          </div>
          {
            this.props.scoreCode !== 'gef' ?
              <div styleName='holding-asset'>
                <b>Company score</b>
              </div> :
              null
          }
          <div styleName='holding-invested'>
            <b>% invested</b>
          </div>
          <div styleName='holding-invested'>
            <b>USD$</b>
          </div>
        </li>

        {
          !this.props.holdings || this.props.holdings.length === 0 ?
            <li styleName='holdings-none'>NONE</li> :
            this.props.holdings.map((h, i) => {
              return <HoldingRow
                key={'holding-row-gef-'+this.props.type+'-'+i}
                idx={i}
                highLow={highLow}
                type={this.props.type}
                holding={h}
                currency={this.props.currency}
                scoreCode={this.props.scoreCode}
              />
            })
        }
      </ul>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
export default class CompanyList extends Component {
  static propTypes = {
    currency: PropTypes.string,
    holdingLists: PropTypes.object,
    scoreCode: PropTypes.string,
    grade: PropTypes.number
  }
  constructor(props){
    super(props);
    const top10Holdings = props.holdingLists.top10
    const bottom10Holdings = props.holdingLists.bottom10

    const count = top10Holdings.length

    const scoreLabel = {
      gef: 'Gender Equality',
      dei: 'Diversity Disclosures',
      rji: 'Racial Justice',
      hrc: 'LGBTQ+ Equity',
    }[props.scoreCode || 'gef'] 

    const topDescription = `Top ${count} holdings by ${scoreLabel} score`
    const bottomDescription = `Bottom ${count} holdings by ${scoreLabel} score`

    this.state = {
      scoreCode: (props.scoreCode || 'gef'),
      scoreLabel,
      topDescription,
      bottomDescription,
      count,
      top10Holdings,
      bottom10Holdings,
    }
  }
  //
  render() {
    if (this.props.grade === 2.5) {
      return null
    }
    
    return <div>
      <h2 styleName='company-list-section-title'>Fund Holdings: {this.state.scoreLabel}</h2>
      {
        this.state.count > 0 ?
          <Row>
            <Col lg={6} md={6} sm={12} xs={12}>
              <HoldingListTable
                type='top'
                currency={this.props.currency}
                description={this.state.topDescription}
                holdings={this.state.top10Holdings}
                scoreCode={this.state.scoreCode}
              />
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <HoldingListTable
                type='bottom'
                currency={this.props.currency}
                description={this.state.bottomDescription}
                holdings={this.state.bottom10Holdings}
                scoreCode={this.state.scoreCode}
              />
            </Col>
          </Row> :
          <div
            style={{
              'textAlign': 'center',
              'marginBottom': '100px'
            }}
          >
            No fund holdings had scores for this issue.
          </div>
      }
    </div>
  }
}

